// Site configuration and contact information

export const siteConfig = {
  name: "ARYA LAKSHMI M",
  title: "Full Stack Developer & AI Engineer",
  tagline: "Building intelligent, scalable web applications that solve real-world problems",
  contact: {
    email: "aryalakshmi.dev@gmail.com",
    phone: "+91 98765 43210",
    whatsapp: "+919876543210",
    linkedin: "https://www.linkedin.com/in/aryalakshmi",
    github: "https://github.com/aryalakshmi"
  },
  seo: {
    description: "Full Stack Developer & AI Engineer specializing in React, Node.js, and Machine Learning. View my portfolio of web applications and AI projects.",
    keywords: [
      "Full Stack Developer",
      "AI Engineer",
      "React Developer",
      "Node.js",
      "Machine Learning",
      "Web Development",
      "Portfolio",
      "Software Engineer"
    ],
    ogImage: "/og-image.png"
  },
  navigation: [
    { label: "Home", path: "/" },
    { label: "Projects", path: "/projects" },
    { label: "Experience", path: "/experience" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" }
  ]
};
